<template>
  <div class="search-wrapper" :class="{'hasDeatil':!hasDeatil}">
    <img class="search-btn" src="../../../../static/img/party-search.png" alt @click="toSearch()">
    <input class="search-input" v-model="searchText" type="text" placeholder="关键字搜索">
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      searchText: "",
      hasDeatil: true
    };
  },
  computed: {
    ...mapGetters(["searchVuex"])
  },
  mounted() {
    this.searchCommon();
  },
  methods: {
    ...mapActions(["setSearch"]),
    toSearch() {
      this.setSearch(this.searchText);
    },
    searchCommon() {
      this.searchText = "";
      this.setSearch("");
      if (this.$route.path.indexOf("detail") > -1||this.$route.path.indexOf("org") > -1) {
        this.hasDeatil = false;
      } else {
        this.hasDeatil = true;
      }
    }
  },
  watch: {
    $route() {
      this.searchCommon();
    }
  }
};
</script>

<style scoped>
.hasDeatil {
  visibility: hidden;
}
.search-wrapper {
  width: 309px;
  height: 40px;
  background: rgba(237, 241, 244, 1);
  border: 1px solid rgba(220, 227, 233, 1);
  border-radius: 10px;
  margin-bottom: 20px;
  position: relative;
}
.search-btn {
  width: 25px;
  height: 26px;
  position: absolute;
  top: 7px;
  right: 10px;
  cursor: pointer;
}
.search-input::placeholder {
  color: #a2a8b8;
}
.search-input {
  width: 100%;
  height: 100%;
  padding: 10px 60px 10px 20px;
  box-sizing: border-box;
  outline: none;
  border: none;
  border-radius: 10px;
  font-size: 18px;
  color: #333;
  background: rgba(237, 241, 244, 1);
}
</style>



// WEBPACK FOOTER //
// src/components/views/PartyBuilding/partySearch.vue